export const MAX_DATE = new Date(2999, 11, 31);
